import React, { useState, useEffect } from "react"
import axios from "axios";
import { CKYCUploadFileWithName, toBase64 } from "./CKYCUploadFileWithName";
const RelationOption = [
    { Key: "Father", Value: "FatherName" },
    { Key: "Mother", Value: "MotherName" },
    { Key: "Spouse", Value: "SpouseName" }
]
const DocTypeUpload = (props) => {
    // DocType
    //DocNumber
    const [Base64Photo, setBase64Photo] = useState("");
    const [Base64POI, setBase64POI] = useState("");
    const [Base64POA, setBase64POA] = useState("");
    const [selectedPOA, setSelectedPOA] = useState("");
    const [selectedPOI, setSelectedPOI] = useState("");
    const [selectedPOIValue, setSelectedPOIValue] = useState("");
    const [selectedPOAValue, setSelectedPOAValue] = useState("");
    const [Relation, setRelation] = useState("FatherName");
    const [RelationName, setRelationName] = useState("");
    const [RcBase64, setRCBase64] = useState("");
    const [PrevPolicyBase64, setPrevPolicyBase64] = useState("");
    useEffect(() => {
        setSelectedPOI(props.CKYCData.filter(row => row.Name.match("PAN"))[0]?.Name);
        setSelectedPOA(props.CKYCData.filter(row => row.Name.match("ADHAR"))[0]?.Name);
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();
        if (props.Companyid === 118 && RelationName.trim() === "") {
            return alert(`Kindly Enter ${Relation} Name`);
        }
        const files = document.querySelectorAll("input[type=file]");
        const formData = new FormData();
        formData.append("insurerID", props.Companyid);
        formData.append("enquiryNo", props.EnquiryNo);
        formData.append("URL", "UploadCKYCFile");
        formData.append("uploadDesc", "PostedFiles");
        files.forEach((f) => {

            if (f.value !== "")
                formData.append(f.id.toLowerCase(), f.files[0]);

        });
        axios.post("/central/centralcall/UploadFile", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(res => {
                if (res.data.StatusCode === 200) {
                    props.setKYCDetails({
                        Base64Photo,
                        Base64POI,
                        Base64POA,
                        IsRedirectUrl: false,
                        IsUploadFile: true,
                        Relation: RelationName + "~" + Relation,
                        SelectedPOA: props.CKYCData.filter(row => row.Name === selectedPOA)[0].Code,
                        SelectedPOI: props.CKYCData.filter(row => row.Name === selectedPOI)[0].Code,
                        SelectedPOIValue: selectedPOIValue,
                        selectedPOAValue: selectedPOAValue
                    });
                    // props.onKYCSubmit();
                } else alert("Kindly Choose File");
            });
    }

    return <>

        <div className="modal fade AnuthorModal show" id="exampleModalDefault33" style={{ display: "block" }} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content CkycUploadDOC CkycUploadDOC002">
                    <div className="modal-header d-block">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">Upload Documents</h1>
                        <button type="button" className="close" onClick={() => props.onKYCSubmit(false)}>X</button>
                    </div>
                    <div className="modal-body">

                        <div id="fileBody" >
                            <form onSubmit={onSubmit}>
                                <CKYCUploadFileWithName DocumentTypeID={selectedPOI} setDocumentType={(data) => setSelectedPOI(data)}
                                    setDocumentID={(data) => setSelectedPOIValue(data)} DocumentIDValue={selectedPOIValue}
                                    setDocumentBase64={(data) => setBase64POI(data)} DocumentBase64={Base64POI} title="Identity" CKYCData={props.CKYCData} />
                                <CKYCUploadFileWithName DocumentTypeID={selectedPOA} setDocumentType={data => setSelectedPOA(data)}
                                    setDocumentID={data => setSelectedPOAValue(data)} DocumentIDValue={selectedPOAValue}
                                    setDocumentBase64={data => setBase64POA(data)} DocumentBase64={Base64POA}
                                    title="Address" CKYCData={props.CKYCData} />
                                {props.Companyid === 128 &&
                                    <div className="row mt-4 mb-4">
                                        <div className="col-md-6">
                                            <div className="UploadDocuments" style={{ display: !RcBase64?"":"none" }}>
                                                <input type="file" accept="image/*" onChange={async e => setRCBase64(await toBase64(e.target.files[0]))} name="rc" id="rc" hidden />
                                                <label htmlFor="rc" className="POS_File_Upload_Box">
                                                    <img src={require("./POS_IMG/upload.svg")} />
                                                    <p>Upload RC</p>
                                                </label>
                                            </div>
                                            {RcBase64 && <div>
                                                <span onClick={() => setRCBase64("")}>Clear</span>
                                                <img src={RcBase64} title="RC Copy" alt="RC Copy" /></div> } 
                                        </div>
                                        <div className="col-md-6">
                                            <div className="UploadDocuments" style={{ display: !PrevPolicyBase64 ? "" : "none" }}>
                                                <input type="file" accept="image/*" onChange={async e => setPrevPolicyBase64(await toBase64(e.target.files[0]))} name="prevpolicy" id="prevpolicy" hidden />
                                                <label htmlFor="prevpolicy" className="POS_File_Upload_Box">
                                                    <img src={require("./POS_IMG/upload.svg")} />
                                                    <p>Upload Previous Policy</p>
                                                </label>
                                            </div>
                                            {PrevPolicyBase64 && <div>
                                                <span onClick={() => setPrevPolicyBase64("")}>Clear</span>
                                                <img src={PrevPolicyBase64} title="Previous Policy Copy" alt="Previous Policy Copy" /></div>} 
                                        </div>
                                    </div>
                                }
                                {props.Companyid === 118 && <div className="row">
                                    <div className="col-md-6">
                                        <select className="packageForm" value={Relation} onChange={e => setRelation(e.target.value)}>
                                            {RelationOption.map((r, i) => <option key={i} value={r.Value}>{r.Key}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <input className="packageForm" type="text" value={RelationName} onChange={e => setRelationName(e.target.value)} />
                                    </div>
                                </div>}
                                <button type="submit" className="btn fileUploadBtn" disabled={Base64POA === "" || Base64POI === ""}>Upload Document</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
export default DocTypeUpload;